module.exports = __webpack_public_path__ + "static/fonts/Nunito-Light.8db55a6.woff";